/* Vogadog
   1) Fiche produit, offre Duo : choix de la couleur du 2e Sac Cocon.
      Couleurs différentes : les deux articles sont ajoutés (1 + 1). Couleurs identiques : quantité 2, comme avant.
   2) Panier en tiroir : un menu « Couleur » sous chaque article permet de changer la couleur d'un exemplaire. */
(function () {
  function base() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function post(path, body) {
    return fetch(base() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function addCss() {
    if (document.getElementById('vd-duo-style')) return;
    var s = document.createElement('style');
    s.id = 'vd-duo-style';
    s.textContent = '.vd-duo[hidden]{display:none!important}.vd-duo{margin:0 0 22px!important}' +
      '.vd-couleur{margin-top:8px;display:flex;flex-wrap:wrap;align-items:center;gap:6px;font:400 13px/1.4 Jost,Helvetica,Arial,sans-serif;color:#161212;letter-spacing:0}' +
      '.vd-couleur[hidden]{display:none!important}' +
      '.vd-couleur select{font:400 13px/1.2 Jost,Helvetica,Arial,sans-serif;color:#161212;background:#fff;border:1px solid rgba(22,18,18,.35);border-radius:0;padding:6px 8px;max-width:100%;cursor:pointer}' +
      '.vd-couleur select:disabled{opacity:.5;cursor:wait}';
    document.head.appendChild(s);
  }

  /* ---------- 1) Fiche produit ---------- */
  function initProduct() {
    var root = document.querySelector('.vg-pdp');
    if (!root || root.querySelector('.vd-duo')) return;
    var form = document.getElementById('VgProductForm');
    var bundle = root.querySelector('[data-vg-bundle]');
    var options = root.querySelectorAll('[data-vg-option]');
    var data = document.querySelector('script[data-vg-variants]');
    if (!form || !bundle || options.length !== 1 || !data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var src = options[0];
    var box = src.cloneNode(true);
    box.removeAttribute('data-vg-option');
    box.classList.add('vd-duo');
    box.hidden = true;
    var legend = box.querySelector('legend');
    if (legend) legend.innerHTML = '<b>Couleur du 2e Sac Cocon :</b> <span class="vd-duo__nom"></span>';
    var nom = box.querySelector('.vd-duo__nom');
    var inputs = box.querySelectorAll('input[type="radio"]');
    var labels = box.querySelectorAll('label');
    inputs.forEach(function (inp, i) {
      var lab = null;
      labels.forEach(function (l) { if (l.getAttribute('for') === inp.id) lab = l; });
      if (!lab) lab = labels[i] || null;
      var id = 'VdDuo-' + i;
      inp.id = id;
      inp.name = 'vd-duo';
      if (lab) {
        lab.setAttribute('for', id);
        if (lab.classList.contains('is-soldout')) { inp.disabled = true; inp.checked = false; }
      }
    });
    bundle.parentNode.insertBefore(box, bundle.nextSibling);

    function firstVal() { var c = src.querySelector('input:checked'); return c ? c.value : null; }
    function secondVal() { var c = box.querySelector('input:checked'); return c ? c.value : null; }
    function idFor(val) {
      var v = variants.find(function (x) { return x.options[0] === val; });
      return v && v.available ? v.id : null;
    }
    function isDuo() { var c = bundle.querySelector('input:checked'); return !!c && c.value === '2'; }
    function sync() {
      box.hidden = !isDuo();
      if (nom) nom.textContent = secondVal() || '';
    }
    bundle.addEventListener('change', function () {
      if (isDuo() && !box.dataset.touched) {
        var fv = firstVal();
        inputs.forEach(function (i) { if (i.value === fv && !i.disabled) i.checked = true; });
      }
      sync();
    });
    box.addEventListener('change', function () { box.dataset.touched = '1'; sync(); });
    box.addEventListener('click', function () { setTimeout(sync, 0); });
    sync();

    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented || !isDuo()) return;
      var a = idFor(firstVal());
      var b = idFor(secondVal());
      if (!a || !b || a === b) return;
      e.preventDefault();
      e.stopPropagation();
      var btn = form.querySelector('[data-vg-add]');
      if (btn) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
      }
      var err = form.querySelector('[data-vg-error]');
      if (err) err.textContent = '';
      post('cart/add.js', {
        items: [{ id: a, quantity: 1 }, { id: b, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
        .then(function (res) {
          if (res.status) {
            if (err) err.textContent = res.description || res.message || 'Impossible d’ajouter ces articles au panier.';
            return;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = base() + 'cart';
          }
        })
        .catch(function () {
          if (err) err.textContent = 'Impossible d’ajouter ces articles au panier. Réessayez.';
        })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); }
        });
    }, true);
  }

  /* ---------- 2) Panier en tiroir : changer la couleur ---------- */
  var products = {};
  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(base() + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    }
    return products[handle];
  }
  function changeColour(drawer, qtyInp, currentId, newId, sel) {
    var qty = parseInt(qtyInp.value, 10) || 1;
    var line = parseInt(qtyInp.getAttribute('data-index'), 10);
    var change = line ? { line: line, quantity: qty - 1 } : { id: String(currentId), quantity: qty - 1 };
    sel.disabled = true;
    post('cart/change.js', change)
      .then(function (r) {
        if (r && r.status) throw new Error('change');
        return post('cart/add.js', {
          items: [{ id: Number(newId), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        });
      })
      .then(function (res) {
        if (res.status || typeof drawer.renderContents !== 'function') { window.location.reload(); return; }
        drawer.renderContents(res);
      })
      .catch(function () { window.location.reload(); });
  }
  function enhanceCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      if (row.querySelector('.vd-couleur')) return;
      var link = row.querySelector('a[href*="/products/"]');
      var qtyInp = row.querySelector('input.quantity__input');
      if (!link || !qtyInp) return;
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var vm = href.match(/variant=(\d+)/);
      var current = vm ? vm[1] : qtyInp.getAttribute('data-quantity-variant-id');
      if (!current) return;
      var holder = document.createElement('div');
      holder.className = 'vd-couleur';
      holder.hidden = true;
      var where = row.querySelector('.cart-item__details') || link.parentNode;
      where.appendChild(holder);
      getProduct(m[1]).then(function (p) {
        if (!holder.isConnected || !p || (p.options || []).length !== 1) return;
        var vars = (p.variants || []).filter(function (v) { return v.available || String(v.id) === String(current); });
        if (vars.length < 2) return;
        var qty = parseInt(qtyInp.value, 10) || 1;
        var id = 'VdCouleur-' + current;
        var lab = document.createElement('label');
        lab.setAttribute('for', id);
        lab.textContent = qty > 1 ? 'Changer la couleur de l’un :' : 'Couleur :';
        var sel = document.createElement('select');
        sel.id = id;
        vars.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          if (String(v.id) === String(current)) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          if (String(sel.value) === String(current)) return;
          changeColour(drawer, qtyInp, current, sel.value, sel);
        });
        holder.appendChild(lab);
        holder.appendChild(sel);
        holder.hidden = false;
      }).catch(function () {});
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(enhanceCart, 80); }
  function start() {
    addCss();
    initProduct();
    enhanceCart();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
